import { Action } from 'redux';
import { Histories } from '../entities';

export enum THistories {
  SET_HISTORIES = 'SET_HISTORIES',
  FETCH_HISTORIES = 'FETCH_HISTORIES'
}

export interface ISetHistories extends Action {
  type: THistories.SET_HISTORIES;
  payload: Histories[];
}
export const ASetHistories = (payload: Histories[]): ISetHistories => ({ type: THistories.SET_HISTORIES, payload });

export interface IFetchHistories extends Action {
  type: THistories.FETCH_HISTORIES;
}
export const AFetchHistories = (): IFetchHistories => ({ type: THistories.FETCH_HISTORIES });
